//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
let d=[[[0,"ConditionName",1,0],[0,"ConditionValue",1,0],[0,"CreationMode",1,0],[0,"CzechName",1,0],[0,"DataType",1,0],[0,"EnglishName",1,0],[0,"EplanId",1,0],[0,"FrenchName",1,0],[0,"GermanName",1,0],[0,"ItalianName",1,0],[0,"JapaneseName",1,0],[0,"KoreanName",1,0],[1,"ParentSelection",0,"AME.SelectAMEBaseNode",0],[0,"PolishName",1,0],[0,"PortugueseName",1,0],[1,"PropertySelection",0,"AME.SelectAMEBaseNode",0],[0,"RussianName",1,0],[0,"SelectedobjectToEdit",1,"NXObject",0],[0,"SimplifiedChineseName",1,0],[0,"SpanishName",1,0],[0,"TraditionalChineseName",1,0],[0,"Type",1,0],[0,"Unit",1,0]],[],[]];
SPLM.AME.CreateEplanNodeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.CreateEplanNodeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.CreateEplanNodeBuilder.Types = Object.freeze({
    "Property" : "Property", "PropertyValue" : "PropertyValue", "Product" : "Product", "FunctionTemplate" : "FunctionTemplate"});

SPLM.AME.CreateEplanNodeBuilder.Mode = Object.freeze({
    "Create" : "Create", "Edit" : "Edit"});

SPLM.AME.CreateEplanNodeBuilder.DataTypeOptions = Object.freeze({
    "Bool" : "Bool", "Integer" : "Integer", "Number" : "Number", "String" : "String", "StringTranslatable" : "StringTranslatable", "Date" : "Date"});

export default SPLM;